import { useState } from 'react';
import { get } from '../utils/network';
import { deleteCookie } from '../utils/utils';

export default function useSearch() {
  const [result, setResult] = useState([]); //almacena los resultados
  const [userHasSearched, setUserHasSearched] = useState(false); //se setea en TRUE luego del proceso
  const [loading, setLoading] = useState(false);

  const search = query => { //recibe los filtros
    setLoading(true)
    //Genera los qery params
    const params = {...query}
    for (const key in query.advancedFilters) {
      params[key] = query.advancedFilters[key]
    }
    delete params.advancedFilters
    // let flatQuery = {...query, ...query.advancedFilters}
    // delete flatQuery.advancedFilters

    get('documents?' + Object.keys(params).map(key => `${key}=${params[key]}`).join('&'))
      .then(response => {
        if (response.status === 401) {
          deleteCookie('isLogged');
          window.location.href = '/#/logout'
        }
        return response.json()
      })
      .then(res =>{
        setResult(res);
        setUserHasSearched(true);
        setLoading(false);
      })
      .catch(error => console.log('error', error))

  };
  
  return { loading, result, userHasSearched, search };
}
